import { React, useState } from "react";
import Footer from "../../components/Footer";
import NyliaButton from "../nyliaButton/NyliaButton.js";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";

import "./Calendar.css";
import * as calendarConstClass from "./CalendarConstants.js";
import EventPopup from "./EventPopup.js";

function filterUpcomingEvents() {
  return calendarConstClass.eventsList
    .filter((event) => new Date(event.endDate || event.startDate) >= new Date())
    .sort((a, b) => new Date(a.startDate - new Date(b.startDate)));
}

function Calendar() {
  const sortedEvents = calendarConstClass.eventsList.sort(
    (a, b) => new Date(a.startDate) - new Date(b.startDate)
  );

  // For filter by name
  const [searchTerm, setSearchTerm] = useState("");
  const [events, setEvents] = useState(filterUpcomingEvents());
  // For display past events button
  const [show, setShow] = useState(true);

  const filteredCards = events.filter((event) =>
    event.eventName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  function pastEventsToggled() {
    setShow(!show);
    if (show) {
      // Include past events
      setEvents(sortedEvents);
    } else {
      // Only upcoming events
      setEvents(filterUpcomingEvents());
    }
  }

  function renderCards() {
    return (
      <Row xs={1} sm={2} md={3} lg={4} xl={5} className="g-4">
        {filteredCards.map((item, idx) => (
          <Col key={idx}>
            <EventPopup
              eventName={item.eventName}
              category={item.category}
              startDate={item.startDate}
              endDate={item.endDate}
              eventTime={item.eventTime}
              location={item.location}
              imageID={item.image}
              links={item.links}
              description={item.description}
              details={item.details}
            />
          </Col>
        ))}
      </Row>
    );
  }

  return (
    <div class="main-container calendar-container">
      <div className="main-img-bkg" id="calendar-section">
        <div className="main-title">
          <h1>CALENDAR</h1>
        </div>
        <div className="main-box">
          <p>
            <br></br>
            Stay organized and inspired all season long as you follow everything
            happening in our studio. Explore classes, rehearsals, and special
            events designed to help every dancer grow, learn, and feel part of
            something meaningful. Take a look at our events below, click each
            for more information, and find the perfect class to begin or
            continue your dance journey with us.
          </p>
          {/* <NyliaButton
            // link={siConstClass.applicationLink}
            label={"APPLY TODAY"}
          ></NyliaButton> */}
        </div>
      </div>
      <div className="main-bkg" id="eventListSection">
        <h1 id="highlightTitle">NYLIA BALLET EVENTS</h1>

        <div className="calendarSearchForm">
          <br></br>
          <Form.Group controlId="filterInput">
            <Form.Control
              type="text"
              placeholder="Search by title..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Form.Group>
          <br></br>{" "}
          <div className="calendarPastEventsToggle">
            <Form.Check
              onClick={() => pastEventsToggled()}
              type="switch"
              id="custom-switch"
              label="Include Past Events"
            />
          </div>
        </div>
        <br></br>
        {renderCards(calendarConstClass.eventsList)}
      </div>

      <Footer></Footer>
    </div>
  );
}

export default Calendar;
